'use strict';

import 'es6';

const navigation = (function(){
    let navItems = null;
    let mobileNav = null;
    let pages = null;
    let activePage = null;
    let activeId = null;

    function init() {
        const page = document.getElementsByClassName('page-section active');
        activePage = page[0] || document.getElementById(window.config.defaultPageId)[0];
        activeId = activePage.id;
        pages = document.getElementsByClassName('page-section');
        navItems = document.getElementsByClassName('navigation__item');
        mobileNav = document.getElementById('mobile-nav');
        const logos = document.getElementsByClassName('logo');

        for (let logo of logos) {
            // Create click handler for items
            logo.addEventListener('click', function(event) {
                event.preventDefault();
                onChange(window.config.defaultPageId);
            });
        }

        for (let item of navItems) {
            // Create click handler for items
            item.addEventListener('click', function(event) {
                event.preventDefault();
                const newId = item.getAttribute('data-page');
                onChange(newId);
            });
        }

        mobileNav.addEventListener('change', function(event) {
            onChange(event.target.value, true);
        });
    }

    function onChange(newId, option = false) {
        if (newId !== activeId) { // Only if page really changes
            activeId = newId;

            if (window.history && window.config.baseUrl) {
                let navId = activeId === window.config.defaultPageId ? '' : activeId + '/';
                window.history.pushState({}, '', window.config.baseUrl+navId);
            }

            // Update navigation
            for (let navItem of navItems) {
                const navId = navItem.getAttribute('data-page');
                if (navId === activeId) {
                    navItem.classList.add('active');
                } else {
                    navItem.classList.remove('active');
                }
            }

            if (!option) {
                // Select correct option
                mobileNav.value = activeId;
            }

            // Update pages
            for (let page of pages) {
                if (page.id === activeId) {
                    page.classList.add('active');

                    const event = new CustomEvent('page-open', {});

                    page.dispatchEvent(event);
                } else {
                    page.classList.remove('active');
                    activePage = page;
                }
            }

            if (window.gtag) {
                window.gtag('config', window.config.ga, { 'page_path': location.pathname });
            }
        }
    }

    function getActivePageId() {
        return activeId;
    }

    return {
        init: init,
        getActivePageId: getActivePageId
    }
})();

export default navigation;
